import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaEdit, FaTrash } from 'react-icons/fa';
import AdminAppBody from '../../../../components/admin/AdminAppBody';
import PageHeading from '../../../../components/admin/common/PageHeading';
import useApiCallHooks from '../../../../hooks/useApiCallHooks';
import { apiRoutes } from '../../../../routes/api/apiRoutes';
import { uiRoutes } from '../../../../routes/ui/uiRoutes';
import { toast } from 'react-toastify';

const ServiceList = () => {
  const [search, setSearch] = useState("");
  const [services, setServices] = useState([]);

  const [res, loading, error, callAPI, statusCode] = useApiCallHooks();

  useEffect(() => {
    callAPI('get', apiRoutes.admin.services);
  }, []);

  useEffect(() => {
    if (res?.data && Array.isArray(res.data)) {
      setServices(res.data);
    }
  }, [res]);

  const handleDelete = (id) => {
    if (window.confirm("Delete this service?")) {
      callAPI('delete', `${apiRoutes.admin.services}/${id}`);
    }
  };

  useEffect(() => {
    if (statusCode === 204) {
      toast.success("Service deleted!");
      callAPI('get', apiRoutes.admin.services);
    }
  }, [statusCode]);

  const filtered = services.filter(service =>
    service.title?.toLowerCase().includes(search.toLowerCase()) ||
    service.description?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <AdminAppBody
      loading={loading}
      content={
        <div className="container">
          <div className="d-flex justify-content-between align-items-center">
            <PageHeading title="Service List" subTitle="Manage your services" />
            <Link to={uiRoutes.admin.services.add}>
              <button className="btn btn-success">Add Service</button>
            </Link>
          </div>

          <div className="my-3">
            <input
              className="form-control"
              placeholder="Search service..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          <div className="table-responsive">
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Title</th>
                  <th>Description</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((service, idx) => (
                  <tr key={service.id}>
                    <td>{idx + 1}</td>
                    <td>{service.title}</td>
                    <td>{service.description}</td>
                    <td>
                      <Link
                        to={uiRoutes.admin.services.edit.replace(":id", service.id)}
                      >

                        
                        <button className="sys-list-table__action edit">
                          <FaEdit />
                        </button>
                      </Link>

                      <button
                        onClick={() => handleDelete(service.id)}
                        className="sys-list-table__action delete"
                      >
                        <FaTrash />
                      </button>
                    </td>
                  </tr>
                ))}
                {filtered.length === 0 && (
                  <tr>
                    <td colSpan="4" className="text-center">No services found.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      }
    />
  );
};

export default ServiceList;
